import React, { useContext, useState } from 'react'
import { jsx, css } from '@emotion/core'
import { Button, Upload, Icon, message } from 'antd'
import qs from 'query-string'
import { connect } from 'react-redux'
import { getApiTargetInfo } from 'core'
import { ErrorContext } from 'context'
import { getCredentials, getAuthorization } from 'api/pgads'

const emptyFunction = _ => _
const WSAccessFileUpload = ({
  // onSuccess = emptyFunction,
  onError = emptyFunction,
  children,
  displayText = 'Click to Upload File',
  style,
  className,
  serviceName,
  endpointName,
  retrieveData,
  targetInfo,
}) => {
  const [fileList, setFileList] = useState(true)
  const { setError } = useContext(ErrorContext)

  const targetUrl = `${
    targetInfo.baseUrl
  }/admin/web-service-access/upload-certificate?${qs.stringify({
    'service-name': serviceName,
    'endpoint-name': endpointName,
  })}`

  const uploadProps = {
    name: 'file',
    ...getCredentials(targetInfo),
    headers: getAuthorization(targetInfo),
    action: targetUrl,
    method: 'POST',
  }

  const onFileUploadChange = info => {
    if (info.file.status === 'done') {
      message.success(`${info.file.name} file uploaded successfully`)
      setFileList(false)
      retrieveData()
    } else if (info.file.status === 'error') {
      setError(info.file.response)
      onError(info)
    }
  }

  return (
    <Upload
      style={style}
      className={className}
      {...uploadProps}
      onChange={onFileUploadChange}
      multiple={false}
      showUploadList={fileList}
    >
      {children || (
        <Button>
          <Icon type="upload" /> {displayText}
        </Button>
      )}
    </Upload>
  )
}
const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(React.memo(WSAccessFileUpload))
